export default "__VITE_ASSET__Bawy9UcD__"